import React, { useEffect } from "react";
import styled from "styled-components";
import darkflix from "../images/darkflix.webp";
import darkflix3 from "../images/darkflix3.webp";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";

const Project1 = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        exit={{ scaleX: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Main>
          <CaseStudy>
            <h2>Darkflix</h2>

            <p>
              I decided to recreate the Frontend of Netflix official Web App as
              I got attracted to their beautiful UI and it was a great
              opportunity for me to showcase my frontend skills by rebuilding
              the UI and it ended up being a great experience for me. <br /> I
              used my frontend tools to build the User Interface which works on
              all types of devices along with the SPA library to make the
              frontend perform faster. <br /> Feel free to check out the Project
              by visiting the Live Link.
            </p>

            <h2>TOOLS USED</h2>

            <div className="tools">
              <code>HTML</code>
              <code>CSS</code>
              <code>JavaScript</code>
              <code>Styled-Components</code>
              <code>React-Redux</code>
              <code>GIT</code>
              <code>GITHUB</code>
              <code>React.JS</code>
            </div>

            <a
              href="https://dam-darkflix.netlify.app"
              target="_blank"
              alt="darkflix"
              rel="noreferrer"
            >
              View Site
            </a>
            <a
              href="https://github.com/damaluku/darkflix"
              target="_blank"
              alt="darkflix"
              rel="noreferrer"
            >
              View Code
            </a>
          </CaseStudy>

          <Slider>
            <img src={darkflix} alt="darkflix" />
            <img src={darkflix3} alt="darkflix3" loading="lazy" />
          </Slider>
        </Main>
      </motion.div>
    </>
  );
};

export default Project1;

const Main = styled.main`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  position: relative;

  @media screen and (max-width: 760px) {
    margin: 4rem 0;
  }
`;

const CaseStudy = styled.div`
  flex: 1;
  padding: 6rem 2rem 0;
  width: 100%;
  height: 100%;

  @media screen and (max-width: 740px) {
    padding: 6rem 0;
  }

  h2 {
    text-align: center;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 3px;
    margin-bottom: 2rem;
  }

  p {
    font-size: 22px;
    margin-bottom: 2rem;
  }

  a {
    font-size: 22px;
    color: ${(props) => props.theme.dark.custom};
    font-weight: bold;
    text-transform: uppercase;
    margin-right: 2rem;
  }

  .tools {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    text-transform: uppercase;
    margin-bottom: 2rem;
    gap: 1rem;
    flex-wrap: wrap;

    code {
      background-color: ${(props) => props.theme.dark.text};
      color: ${(props) => props.theme.dark.primary};
      padding: 5px 10px;
      font-weight: bold;
    }
  }
`;

const Slider = styled.div`
  margin-top: 2rem;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  display: flex;
  overflow-x: scroll;

  ::-webkit-scrollbar {
    display: none;
  }

  img {
    height: 350px;
    object-fit: contain;
    margin: 0 2rem;
  }

  @media screen and (max-width: 740px) {
    img {
      width: 95%;
      min-height: 250px;
      object-fit: cover;
    }
  }
`;
